module.exports = __webpack_public_path__ + "static/autodarkmode-6467d8965954d978ae0ff20b61aa23eb.png";